// Data of a new record made from the interface: the title, the chosen event, and a first stage for each required stage field,
// so a record made in one click passes the server's checks (the section's «+» button and «создать и привязать» share it).

import type { Id, MetaIndex } from '@confdeck/core-shared';

export function newRecordData(meta: MetaIndex, typeId: Id, title: string, opts: { scope?: { field: string; id: Id } | null; pipelineId?: Id | null } = {}): Record<string, unknown> {
  const type = meta.type(typeId)!;
  const data: Record<string, unknown> = { [type.titleField]: title };
  // A new record lands in the chosen scope (R-E1: «новая запись создаётся в выбранном событии»).
  if (opts.scope) data[opts.scope.field] = [opts.scope.id];
  // A required stage gets the first working stage; a managed one is set by its command (or a scenario).
  for (const f of meta.fields(typeId)) {
    if (!f.required || f.options.managed || f.fieldType !== 'taxonomy' || !f.options.taxonomyId) continue;
    const tax = meta.taxonomy(f.options.taxonomyId)!;
    // The pipeline of the page the person is on, when it is of this field (a deal made on the page of its pipeline); else the first one.
    const own = opts.pipelineId && meta.term(opts.pipelineId)?.taxonomyId === tax.id ? opts.pipelineId : null;
    const root = own ?? (tax.style === 'pipeline' ? meta.children(null, tax.id).find((p) => !p.archivedAt)?.id : null);
    const first = tax.style === 'pipeline' ? meta.children(root ?? null, tax.id)[0] : meta.terms(tax.id)[0];
    if (first) data[f.key] = f.options.multiple ? [first.id] : first.id;
  }
  return data;
}
